<template>
  <div>
    <el-dialog
      title="接品数量"
      :visible.sync="dialogVisible"
      width="1080px"
      :before-close="handleClose"
    >
      <div class="dl-page">
        <div class="table-wrap">
          <MyTable
            :table-data="tableData"
            :index="index"
            :selection="selection"
            :operation="false"
            :showpage="false"
            :table-option.sync="tableOption"
          >
            <template slot="operatorInformation" slot-scope="scope">
              <div>
                {{ scope.row.contactName }}
                {{ scope.row.contactPhone ? "&" + scope.row.contactPhone : "" }}
              </div>
            </template>
            <!-- 商品信息 -->
            <template slot="goodsMessage" slot-scope="scope">
              <div class="goods-layout">
                <el-image
                  class="big-icon"
                  :src="scope.row.goodsMessage.pictureAddress"
                />
                <div class="txt-layout">
                  <div class="txt-row title">
                    {{ scope.row.goodsMessage.goodsName }}
                  </div>
                  <div class="txt-row">
                    {{ scope.row.goodsMessage.specification }}
                  </div>
                  <div class="txt-row">
                    {{ scope.row.goodsMessage.manufacturer }}
                  </div>
                  <div class="txt-row">{{ scope.row.goodsMessage.mpn }}</div>
                  <div class="txt-row">
                    {{ scope.row.goodsMessage.goodsCode }}
                  </div>
                </div>
              </div>
            </template>
            <!-- 商品信息 -->
            <template slot="status" slot-scope="scope">
              <div>{{ showStatus(scope.row) }}</div>
            </template>
          </MyTable>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="right">
          <el-button @click="handleClose" size="small">取 消</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import MyTable from "@/components/myTable";

import { getSalesUserReceiveGoodsManageBySalesId } from "@/api/externalSalesRule/index.js";
import _ from "lodash";

export default {
  components: { MyTable },
  props: {
    requestId: {
      type: String,
      default: () => "",
    },

    limit: {
      type: Number,
      default: () => 10,
    },
  },
  computed: {
    headers: function () {
      return {
        Authorization: "Bearer " + getToken(),
      };
    },
  },
  data() {
    return {
      rowData: null,

      tabsIndex: "-1",
      operation: true,
      selection: false,
      index: false,
      tableData: [],
      tableOption: [
        { label: "客户名称", prop: "shopName", minWidth: 120 },
        { label: "部门名称", prop: "sectionName", minWidth: 120 },
        {
          label: "运营人员&联系方式",
          prop: "operatorInformation",
          slot: true,
          minWidth: 160,
        },
        {
          label: "商品信息",
          prop: "goodsMessage",
          slot: true,
          minWidth: 260,
        },
        {
          label: "售价",
          prop: "sellingPrice",
          minWidth: 120,
        },
        {
          label: "推广服务费比例",
          prop: "promotionServiceFeeRatio",
          minWidth: 120,
        },
        { label: "试用期/天", prop: "probationPeriod", minWidth: 120 },
        { label: "试用期任务", prop: "probationPeriodQuest", minWidth: 120 },
        { label: "合作期/天", prop: "cooperationPeriod", minWidth: 120 },
        { label: "状态", prop: "status", slot: true, minWidth: 120 }, //合作状态（已合作：YES，未合作：NO，拒绝合作：REFUSE，取消合作：CANCEL）
      ],

      dialogVisible: false,
    };
  },
  methods: {
    showStatus(row) {
      let status = "";
      if (row.status === "YES") {
        status = "已合作";
      } else if (row.status === "NO") {
        status = "未合作";
      } else if (row.status === "REFUSE") {
        status = "拒绝合作";
      } else if (row.status === "CANCEL") {
        status = "取消合作";
      }
      return status;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    init() {
      //
    },
    getList() {
      const salesUserId = this.rowData.id;

      getSalesUserReceiveGoodsManageBySalesId(salesUserId).then((data) => {
        if (data && data.length > 0) {
          this.tableData = data;
        } else {
          this.tableData = [];
        }
      });
    },
    clear() {
      this.rowData = null;
      this.tableData = [];
    },
    open(row) {
      this.clear();
      this.dialogVisible = true;

      this.rowData = _.cloneDeep(row);

      this.getList();
    },
  },
};
</script>
<style scoped lang="scss">
@import "../style/index.scss";
.goods-layout {
  display: flex;
  flex-direction: row;
  align-items: center;

  .big-icon {
    width: 80px;
    height: 80px;
    flex-shrink: 0;
  }

  .txt-layout {
    margin-left: 4px;
    flex: 1;
    display: flex;
    flex-direction: column;

    .txt-row {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #8c8c8c;

      &.title {
        color: #262626;
      }
    }
  }
}
</style>
